import React, { Fragment } from 'react';
import { Check } from 'lucide-react';
interface Step {
  number: number;
  label: string;
}
interface StepIndicatorProps {
  currentStep: number;
  steps: Step[];
}
export function StepIndicator({
  currentStep,
  steps
}: StepIndicatorProps) {
  return <div className="bg-white border-b border-gray-200 px-8 py-6" data-id="element-228">
      <div className="flex items-center justify-between max-w-5xl mx-auto" data-id="element-229">
        {steps.map((step, index) => {
        const isCompleted = currentStep > step.number;
        const isCurrent = currentStep === step.number;
        const isUpcoming = currentStep < step.number;
        return <Fragment key={step.number} data-id="element-230">
              <div className="flex flex-col items-center" data-id="element-231">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-colors ${isCompleted ? 'bg-green-600 text-white' : isCurrent ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'}`} data-id="element-232">
                  {isCompleted ? <Check className="w-5 h-5" data-id="element-233" /> : step.number}
                </div>
                <span className={`mt-2 text-xs font-medium ${isCurrent ? 'text-blue-600' : isCompleted ? 'text-green-600' : 'text-gray-500'}`} data-id="element-234">
                  {step.label}
                </span>
              </div>
              {index < steps.length - 1 && <div className="flex-1 h-0.5 mx-4 mb-6" data-id="element-235">
                  <div className={`h-full transition-colors ${isCompleted ? 'bg-green-600' : 'bg-gray-200'}`} data-id="element-236" />
                </div>}
            </Fragment>;
      })}
      </div>
    </div>;
}